export enum UserErrorCode {
    EMAIL_ALREADY_IN_USE = "EMAIL_ALREADY_IN_USE",
}